import { Outlet } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";
import TopBanner from "./TopBanner";
import Navbar from "./Navbar";
import FooterSection from "./FooterSection";
import SEO from "./SEO";
import WelcomeDialog from "./WelcomeDialog";

const Layout = () => {
  const { dir, lang } = useLanguage();

  return (
    <div className={`min-h-screen bg-background ${lang === "ar" ? "font-tajawal" : "font-ember"}`} dir={dir}>
      <SEO />
      <TopBanner />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <FooterSection />
      <WelcomeDialog />
    </div>
  );
};

export default Layout;
